import { DateTime } from 'luxon';

export function getCurrentDate() {
    return DateTime.now().toFormat('yyyy-MM-dd');
}
